import { useLayoutEffect } from 'react';
import classNames from 'classnames/bind';
import { get } from 'lodash';
import { Dotdotdot } from 'taboola-ultimate-ui';
import { useElementSize } from 'taboola-ultimate-ui';
import { DropdownCopyId } from '../DropdownCopyId/DropdownCopyId';
import styles from './DropdownOptionRenderer.module.scss';

const classNameBuilder = classNames.bind(styles);

export const DropdownOptionRenderer = ({
    data,
    innerProps = {},
    idPropName,
    namePropName,
    icon,
    getValue,
    noIconPlaceholder,
    isFocused,
    isSelected,
    editButtonComponent,
    entity,
    updateItemHeight,
    index,
}) => {
    const { onClick, ...restInnerProps } = innerProps;
    const { ref: itemSizeRef, height: itemHeight } = useElementSize();
    // eslint-disable-next-line
    const active = get(data, idPropName) == get(getValue(), `${idPropName}`);
    const containerClassName = classNameBuilder('container', {
        'is-selected': isSelected,
        'is-focused': isFocused,
        'is-inactive': !active,
    });

    useLayoutEffect(() => {
        if (itemHeight) {
            updateItemHeight(index, itemHeight);
        }
    }, [itemHeight, index, updateItemHeight]);

    return (
        <div
            className={classNameBuilder('container', { active }, containerClassName)}
            onClick={onClick}
            {...restInnerProps}
            ref={itemSizeRef}
            tabIndex="-1"
        >
            {icon && (
                <div className={classNameBuilder('icon', { 'no-icon-placeholder': noIconPlaceholder })}>{icon}</div>
            )}
            <div className={styles['rest']}>
                <Dotdotdot lines={2} className={styles['name']}>
                    {get(data, namePropName)}
                </Dotdotdot>
                {!data?.hideId && (
                    <div className={classNameBuilder('id-container')}>
                        <DropdownCopyId value={get(data, idPropName)} label="ID" />
                    </div>
                )}
            </div>
            {editButtonComponent && !data?.hideId && (
                <div className={styles['edit-button-container']}>{editButtonComponent({ entity, data })}</div>
            )}
        </div>
    );
};
